import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconBook = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} defaultGradientKey="ultimate" {...props}>
      <Path d="M9.62517 1.69607C8.26632 0.980831 5.5882 2.36285 4.81886 3.57953C4.47612 4.12398 4.50037 4.51632 4.50037 4.73892V16.6476L14.5434 22.8968L16.432 21.8656V10.268L6.12045 4.34766C6.67379 3.65125 7.91826 2.80204 8.8514 3.14311L18.036 8.05543L18.0361 20.9752L19.9294 19.9422V7.02266L9.62517 1.69607Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
